import React, { useState, useEffect } from "react";
import TimeToDo from "./TimeToDo";

export default function Tasks({
  taskGroups,
  isEdit,
  setEdit,
  setfinishedlevel,
}) {
  const [activeTask, setActiveTask] = useState(0);
  const [startX, setStartX] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [timeFormat, setTimeFormat] = useState(12);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [taskStarted, setTaskStarted] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState(
    () =>
      taskGroups.find((group) => group.tasks.length > 0)?.tasks[0].taskId ||
      null
  );

  const [checkedTasks, setCheckedTasks] = useState(() => {
    const savedTasks = localStorage.getItem("checkedTasks");
    if (savedTasks) {
      return JSON.parse(savedTasks);
    }
    return taskGroups.reduce((acc, group) => {
      group.tasks.forEach((task) => {
        acc[task.taskId] = task.isChecked || false;
      });
      return acc;
    }, {});
  });

  useEffect(() => {
    localStorage.setItem("checkedTasks", JSON.stringify(checkedTasks));
  }, [checkedTasks]);

  const curr_time_in_sec =
    currentTime.getHours() * 3600 +
    currentTime.getMinutes() * 60 +
    currentTime.getSeconds();

  useEffect(() => {
    const interval = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const totalTasks = taskGroups.reduce(
      (acc, group) => acc + group.tasks.length,
      0
    );
    const completedTasks = taskGroups.reduce(
      (acc, group) =>
        acc + group.tasks.filter((task) => checkedTasks[task.taskId]).length,
      0
    );
    setfinishedlevel(totalTasks ? (completedTasks / totalTasks) * 100 : 0);
  }, [checkedTasks, setfinishedlevel]);

  const handleScroll = (direction) => {
    setActiveTask(
      (prev) =>
        (prev + direction + filteredTaskGroups.length) %
        filteredTaskGroups.length
    );
  };

  const handleSwipe = (endX) => {
    const deltaX = startX - endX;
    if (deltaX > 50) handleScroll(1);
    else if (deltaX < -50) handleScroll(-1);
  };

  const filteredTaskGroups = taskGroups.filter(
    (group) => group.tasks.length > 0
  );

  if (!filteredTaskGroups.length) {
    return <button onClick={() => setEdit(!isEdit)}>Add task</button>;
  }

  const formatTime = (timeToDo) =>
    timeFormat === 12
      ? `${timeToDo % 12 || 12} - ${(timeToDo + 1) % 12 || 12} ${
          timeToDo >= 12 ? "PM" : "AM"
        }`
      : `${timeToDo} - ${timeToDo + 1}`;

  const calculateRemainingTime = (task, group) => {
    const taskIndex = group.tasks.findIndex((t) => t.taskId === task.taskId);
    const accumulatedTime_in_sec = group.tasks
      .slice(0, taskIndex)
      .reduce((sum, task) => sum + task.timeRequired * 60, 0);
    const taskStartTime_in_sec = group.timeToDo * 3600 + accumulatedTime_in_sec;
    const taskEndTime_in_sec = taskStartTime_in_sec;
    return taskEndTime_in_sec - curr_time_in_sec;
  };

  return (
    <div
      className="main"
      onTouchStart={(e) => {
        // e.preventDefault();
        setStartX(e.touches[0].clientX);
      }}
      onTouchEnd={(e) => handleSwipe(e.changedTouches[0].clientX)}
      onMouseDown={(e) => {
        setStartX(e.clientX);
        setIsDragging(true);
      }}
      onMouseUp={(e) => {
        if (isDragging) handleSwipe(e.clientX);
        setIsDragging(false);
      }}
    >
      <div className="tasks">
        {filteredTaskGroups.map((group, index) => {
          const totalGroups = filteredTaskGroups.length;
          const relativeIndex =
            (index - activeTask + totalGroups) % totalGroups;

          let isFocused = false;
          let isRight = false;
          let isLeft = false;

          if (totalGroups === 1) {
            isFocused = true;
          } else if (relativeIndex === 0) {
            isFocused = true;
          } else if (relativeIndex === 1) {
            isRight = true;
          } else if (relativeIndex === filteredTaskGroups.length - 1) {
            isLeft = true;
          }

          return (
            <TimeToDo
              key={index}
              group={group}
              isFocused={isFocused}
              isLeft={isLeft}
              isRight={isRight}
              formatTime={formatTime}
              selectedTaskId={selectedTaskId}
              setSelectedTaskId={setSelectedTaskId}
              calculateRemainingTime={calculateRemainingTime}
              checkedTasks={checkedTasks}
              setCheckedTasks={setCheckedTasks}
              taskStarted={taskStarted}
              setTaskStarted={setTaskStarted}
              curr_time_in_sec={curr_time_in_sec}
            />
          );
        })}
      </div>
    </div>
  );
}
